import { Box } from '@mui/system'
import { useWallet } from '@terra-money/wallet-provider'
import OpenNewWindow from 'assets/icons-orange/open-new-window.svg'
import openInFinder from 'utils/openInFinder'

interface Props {
  address: string
  type: 'address' | 'tx'
}
const OpenInFinder = ({ type, address }: Props) => {
  const {
    network: { chainID },
  } = useWallet()

  return (
    <Box
      sx={{ cursor: 'pointer' }}
      onClick={() => openInFinder({ address, type, chainID })}
    >
      <img src={OpenNewWindow} alt="OpenNewWindow" height={16} width={16} />
    </Box>
  )
}

export default OpenInFinder
